import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 30.8.",
  "description": "",
  "published": "2011-08-30T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-30-8/swizec/2308"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Elearnroom1.jpg",
        "alt": "picture of an e-learning classroom",
        "title": "picture of an e-learning classroom"
      }}></img></p>
    <p>{`Today I learned that studying from textbooks of other majors than your own can be quite an interesting experience. Serendipity and stuff! Namely I was going through an architect's book for their statics class. While certainly an entertaining read, I was absolutely abhorred by their raping of basic physics.`}</p>
    <p>{`Now I'm no physics buff myself, took me ages to pass that exam, but even as a lowly programmer it was painful reading such primary school explanations of things like balance and vectors and stuff like that. You're supposed to be a university level textbook for fuck's sake! For a profession that is historically and in the public's mind seen as very noble and educated!`}</p>
    <p>{`How dare they confuse balance and lack of acceleration upon an object? (sum of torques being zero versus sum of forces acting upon an object being zero) And I was absolutely mortified when I read that forces cannot be moved around the system. You know, because a vector totally changes if you move it somewhere while taking care not to change any angles or lengths ...`}</p>
    <p>{`But enough, it was still quite interesting.`}</p>
    <p>{`Another thing that I learned is that `}<em parentName="p">{`taking powernaps at 5am does not fucking work`}</em>{`. This is a lesson that never sticks to me, I always end up doing it, and then upon exam time I always bash myself over the head for falling asleep and not having gone through the last couple of pages of material. And it was such an easy and awesome exam too!`}</p>
    <p>{`You never know though, perhaps the four hours of sleep had a much better effect than four more hours of studying would have. I should test this ... but how?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.geek.com/articles/apple/the-kno-app-turns-textbooks-into-a-3d-experience-20110822/"
        }}>{`The Kno app turns textbooks into a 3D experience`}</a>{` (geek.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techland.time.com/2011/08/29/can-digital-textbooks-truly-replace-the-print-kind/"
        }}>{`Can Digital Textbooks Truly Replace the Print Kind?`}</a>{` (techland.time.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.theage.com.au/national/education/a-textbook-case-for-digital-learning-20110815-1iujw.html"
        }}>{`A textbook case`}</a>{` (theage.com.au)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.teleread.com/uncategorized/kno-adds-kahn-academy-resources-to-etextbooks/"
        }}>{`Kno adds Kahn Academy resources to etextbooks`}</a>{` (teleread.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=27b70712-8dd9-4829-8b8b-d5ff3a598dc4",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      